module.exports = __webpack_public_path__ + "img/slide_05.517ea703.png";